!function ($) {
  "use strict";

  //  document ready start 🚩
  $(document).ready(function () {
    // mobile menu

    const $menu = $("#mobileMenu");
    const $searchicon = $(".search-open");
    const $searchbar = $(".search-bar");
    const $overlay = $("#overlay");
    const $goback = $(".goback");
    const $closemenu = $(".close-menu");
    const $hamburger = $("#hamburgerBtn");

    // Open Menu
    $hamburger.on("click", function () {
      $menu.addClass("active");
      $overlay.addClass("active");
      $("body").css("overflow", "hidden"); // prevent body scroll
    });

    // open seach
    $searchicon.on("click", function () {
      $searchbar.css("display", "flex");
      $overlay.addClass("active");
      $("body").css("overflow", "hidden");
    });

    // Close Menu on overlay click
    $overlay.on("click", function () {
      $menu.removeClass("active");
      $overlay.removeClass("active");
      $searchbar.css("display", "none");
      $("body").css("overflow", "auto");
    });

    $closemenu.on("click", function () {
      $menu.removeClass("active");
      $overlay.removeClass("active");

      $("body").css("overflow", "auto");
    });

    $goback.on("click", function () {
      $overlay.removeClass("active");
      $searchbar.css("display", "none");
      $("body").css("overflow", "auto");
    });

    $(".main-nav .main-nav__item.has-dropdown > .main-nav__link").on(
      "click",
      function (e) {
        if ($(window).width() <= 768) {
          e.preventDefault();

          const $parentItem = $(this).closest(".main-nav__item");

          // Toggle active class for current
          $parentItem.toggleClass("active");

          // Slide toggle dropdown menu
          $parentItem
            .find("> .dropdown-menu")
            .stop(true, true)
            .slideToggle(250);

          // Optional: close other open dropdowns
          $(".main-nav__item.has-dropdown")
            .not($parentItem)
            .removeClass("active")
            .find("> .dropdown-menu")
            .slideUp(250);
        }
      }
    );

    $(".hero-slide").slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
    });

    // cart item slider

    $(".highlight-slider").slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,

      speed: 600,

      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: `<svg class="prev" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_1699_27909)">
<rect x="3.33301" width="55" height="55" rx="27.5" fill="white" shape-rendering="crispEdges"/>
<path d="M34.3753 35.8332L35.8545 34.354L29.0003 27.4998L35.8545 20.6457L34.3753 19.1665L26.042 27.4998L34.3753 35.8332Z" fill="#566E31"/>
</g>
<defs>
<filter id="filter0_d_1699_27909" x="-0.000325441" y="0" width="61.6667" height="61.6667" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="3.33333"/>
<feGaussianBlur stdDeviation="1.66667"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.337255 0 0 0 0 0.431373 0 0 0 0 0.192157 0 0 0 0.57 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1699_27909"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1699_27909" result="shape"/>
</filter>
</defs>
</svg>
`,
      nextArrow: `<svg class="next" width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_1699_27905)">
<rect x="3.33301" width="55" height="55" rx="27.5" fill="white" shape-rendering="crispEdges"/>
<path d="M27.5212 35.8332L26.042 34.354L32.8962 27.4998L26.042 20.6457L27.5212 19.1665L35.8545 27.4998L27.5212 35.8332Z" fill="#566E31"/>
</g>
<defs>
<filter id="filter0_d_1699_27905" x="-0.000325441" y="0" width="61.6667" height="61.6667" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="3.33333"/>
<feGaussianBlur stdDeviation="1.66667"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.337255 0 0 0 0 0.431373 0 0 0 0 0.192157 0 0 0 0.57 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1699_27905"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1699_27905" result="shape"/>
</filter>
</defs>
</svg>
`,
    });

    $(".testimonial-slider").slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            variableWidth: false,
          },
        },
      ],
    });
    // margquee
    // function initializeMarquee() {
    //   const $announcementBar = $("#header-announcement-bar");
    //   const $marqueeList = $announcementBar.find("ul");
    //   const contentWidth = $marqueeList.outerWidth(true);

    //   $marqueeList.css({
    //     display: "flex",
    //     animation: "marquee-single linear infinite",
    //   });

    //   // Add CSS for single content animation
    //   $("<style>")
    //     .text(
    //       `
    //     @keyframes marquee-single {
    //       0% {
    //         transform: translateX(100%);
    //       }
    //       100% {
    //         transform: translateX(-100%);
    //       }
    //     }
    //     .header-announcement-bar {
    //       overflow: hidden;
    //     }
    //   `
    //     )
    //     .appendTo("head");

    //   // Set animation duration
    //   const duration = contentWidth * 30;
    //   $marqueeList.css("animation-duration", duration + "ms");
    // }

    // initializeMarquee();

    var elements = $("ul.marquee-item-list li").length;
    for (var i = 0; i < elements; i++) {
      $(".marquee-item-list").clone().prependTo(".marquee-block");
    }

    //FAQ section according
    $(".question-box").click(function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(".question-box").removeClass("active");
        $(this).addClass("active");
      }
    });

    $(".pdp-banner-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      draggable: false,
      asNavFor: ".pdp-banner-slider-nav",
      responsive: [
        {
          breakpoint: 640,
          settings: {
            draggable: true,
            arrows: false,
          },
        },
      ],
    });
    // $(".pdp-banner-slider-nav").slick({
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   vertical: true,
    //   asNavFor: ".pdp-banner-slider",
    //   centerMode: false,
    //   focusOnSelect: true,
    //   prevArrow: ".thumb-prev",
    //   nextArrow: ".thumb-next",
    // });

    const sliderNav = $(".pdp-banner-slider-nav");

    sliderNav.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: ".pdp-banner-slider",
      centerMode: false,
      focusOnSelect: true,
      // prevArrow: ".thumb-prev",
      // nextArrow: ".thumb-next",
      responsive: [
        {
          breakpoint: 640,
          settings: {
            vertical: false,
            infinite: true,
            variableWidth: false,
          },
        },
      ],
    });

    // Handle custom navigation when slide count equals slidesToShow
    $(".thumb-prev").on("click", function () {
      const currentIndex = sliderNav.slick("slickCurrentSlide");
      const totalSlides = sliderNav.slick("getSlick").slideCount;
      const newIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      sliderNav.slick("slickGoTo", newIndex);
    });

    $(".thumb-next").on("click", function () {
      const currentIndex = sliderNav.slick("slickCurrentSlide");
      const totalSlides = sliderNav.slick("getSlick").slideCount;
      const newIndex = (currentIndex + 1) % totalSlides;
      sliderNav.slick("slickGoTo", newIndex);
    });

    // --- Tabs (Desktop) pdp---
    $(".tab").on("click", function () {
      var tabId = $(this).data("tab");

      $(".ingredient-block .each-item:nth-child(n+7)").fadeOut(
        500,
        function () {
          // Optionally reset display to 'none' after fadeOut is complete
          $(this).css("display", "none");
        }
      );

      $("#viewMoreBtn").show();

      // Reset all
      $(".tab").removeClass("active");
      $(".tab-pane").removeClass("active").hide();

      // Activate clicked
      $(this).addClass("active");
      $("#" + tabId)
        .addClass("active")
        .show();

      // ✅ Ensure accordion-content is visible on desktop
      if ($(window).width() >= 768) {
        $("#" + tabId)
          .find(".accordion-content")
          .show();
      }
    });

    // --- Accordion (Mobile) ---
    let touchStartY = 0;
    let touchEndY = 0;

    $(".accordion").on("touchstart", function (e) {
      touchStartY = e.originalEvent.touches[0].clientY;
    });

    $(".accordion").on("touchend", function (e) {
      touchEndY = e.originalEvent.changedTouches[0].clientY;
      const touchDiff = Math.abs(touchStartY - touchEndY);

      // Only trigger if it's a tap (minimal movement)
      if (touchDiff < 10) {
        handleAccordionClick($(this));
      }
    });

    // Fallback for non-touch devices
    $(".accordion").on("click", function (e) {
      if (!("ontouchstart" in window)) {
        handleAccordionClick($(this));
      }
    });

    function handleAccordionClick($this) {
      var $content = $this.next(".accordion-content");

      $(".ingredient-block .each-item:nth-child(n+7)").fadeOut(
        500,
        function () {
          $(this).css("display", "none");
        }
      );
      $("#viewMoreBtn").show();

      $this.toggleClass("active");
      $content.stop(true, true).slideToggle(200);
    }

    // Prevent accordion from closing during scroll
    $(document).on("touchmove scroll", ".accordion-content", function (e) {
      e.stopPropagation();
    });

    // --- Responsive Layout Handling ---
    function adjustLayout() {
      if ($(window).width() < 768) {
        // MOBILE MODE
        $(".tab-pane").show(); // keep all panes visible for accordions
        // Don't hide accordion content that's already active
        $(".accordion-content")
          .not(".accordion.active + .accordion-content")
          .hide();
      } else {
        // DESKTOP MODE
        $(".tab-pane").hide(); // hide all first
        $(".tab-pane.active").show(); // show active pane only
        $(".tab-pane.active .accordion-content").show(); // ✅ ensure its inner content visible
      }
    }

    adjustLayout();
    $(window).on("resize", adjustLayout);

    // pdp view more
    $("#viewMoreBtn").click(function () {
      // Smoothly reveal the hidden items using fadeIn
      $(".ingredient-block .each-item:nth-child(n+7)").css("display", "flex");

      // Optionally hide the "View More" button after it's clicked
      $(this).hide();
    });

    // quantity add to cart funct.
    var variantCurrentId;
    var currentQuantity = 1;

    var QtyInput = (function () {
      var $qtyInputs = $(".qty-input");

      if (!$qtyInputs.length) {
        return;
      }

      var $inputs = $qtyInputs.find(".product-qty");
      var $countBtn = $qtyInputs.find(".qty-count");
      var qtyMin = parseInt($inputs.attr("min"));
      var qtyMax = parseInt($inputs.attr("max"));

      $inputs.change(function () {
        var $this = $(this);
        var $minusBtn = $this.siblings(".qty-count--minus");
        var $addBtn = $this.siblings(".qty-count--add");
        var qty = parseInt($this.val());
        currentQuantity = qty;
        if (isNaN(qty) || qty <= qtyMin) {
          $this.val(qtyMin);
          $minusBtn.attr("disabled", true);
        } else {
          $minusBtn.attr("disabled", false);

          if (qty >= qtyMax) {
            $this.val(qtyMax);
            $addBtn.attr("disabled", true);
          } else {
            $this.val(qty);
            $addBtn.attr("disabled", false);
          }
        }
      });

      $countBtn.click(function () {
        var operator = this.dataset.action;
        var $this = $(this);
        var $input = $this.siblings(".product-qty");
        var qty = parseInt($input.val());

        if (operator == "add") {
          qty += 1;
          if (qty >= qtyMin + 1) {
            $this.siblings(".qty-count--minus").attr("disabled", false);
          }

          if (qty >= qtyMax) {
            $this.attr("disabled", true);
          }
        } else {
          qty = qty <= qtyMin ? qtyMin : (qty -= 1);

          if (qty == qtyMin) {
            $this.attr("disabled", true);
          }

          if (qty < qtyMax) {
            $this.siblings(".qty-count--add").attr("disabled", false);
          }
        }

        $input.val(qty);
        currentQuantity = qty;
      });
    })();

    // Variant change on product page

    const firstVariant = $(".variant-card-item").first();
    console.log(firstVariant, "firstttt");

    if (firstVariant.length) {
      firstVariant.addClass("current-variant");

      const firstPrice = parseFloat(firstVariant.attr("variant-price")) / 100;
      const formattedPrice = firstPrice.toFixed(2);
      $("#updatePrice").text(`Price : ₹ ${formattedPrice}`);
    }

    $(document).on("click", ".variant-card-item", function () {
      // Remove existing highlights
      $(
        ".pdp-price-container, .pdp-cod-container .pdp-cod, .variant-card-item"
      ).removeClass("current-variant");

      // Add active state to clicked variant
      $(this).addClass("current-variant");

      $(".product-qty").val(1);

      // Get variant data
      variantCurrentId = $(this).attr("variant-id");
      let variantCurrentPrice = parseFloat($(this).attr("variant-price")) / 100; // Convert paise to rupees

      // Format to 2 decimal places
      let formattedPrice = variantCurrentPrice.toFixed(2);
      // Update COD & price elements
      $(`.pdp-cod-container .pdp-cod[vid="${variantCurrentId}"]`).addClass(
        "current-variant"
      );
      $(`#${variantCurrentId}`).addClass("current-variant");

      // ✅ Update the displayed price
      $("#updatePrice").text(`Price : ₹ ${formattedPrice}`);

      console.log(variantCurrentId, variantCurrentPrice);
    });

    $(".addToCart").on("click", function (event) {
      event.preventDefault(); // Prevent default form submission
      // $(".highlight-slider").slick("unslick");

      if (variantCurrentId === undefined) {
        var variantId = $(this).data("variant-id");
      } else {
        var variantId = variantCurrentId;
      }
      // Do something with the variantId (e.g., add it to the cart)
      console.log("Variant ID:", variantId);

      var item = {
        id: variantId,
        quantity: currentQuantity,
      };

      // Make a POST request to add the product to the cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(item),
      })
        .then(function (response) {
          console.log("Updated Cart");

          if (!$(event.target).hasClass("buyNow-btn")) {
            dropdowncart();

            $("#cart_drawer").addClass("active");

            $(".highlight-slider").slick("refresh");

            // window.location.href = "/checkout";
            $("html,body").css({
              overflow: "hidden",
            });
            return;
          } else {
            openRzpCheckout(event);
          }
        })
        .catch((error) => console.error("Error:", error));
    });
    $(document).on("click", ".buy-now", function () {
      if (variantCurrentId === undefined) {
        var variantId = $(this).data("variant-id");
      } else {
        var variantId = variantCurrentId;
      }
      // Do something with the variantId (e.g., add it to the cart)
      console.log("Variant ID:", variantId);
      let qty = $(".quantity-container .product-qty").val();

      console.log(qty, "shjssj jshds jhdsd sj");
      qty = qty && !isNaN(qty) && qty > 0 ? qty : 1;

      const item = {
        id: variantId,
        quantity: qty,
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(item),
      })
        .then(function () {
          update_header_cart();
          window.location.href = "/checkout";
        })
        .catch((error) => console.error("Error:", error));
    });

    window.addEventListener("load", function () {
      const alphaOnly = document.querySelectorAll(
        "#RegisterForm-FirstName, #RegisterForm-LastName,#AddressFirstNameNew, #AddressLastNameNew, #AddressCityNew, #AddressFirstNameEdit, #AddressLastNameEdit, .AAddressFirstName, .AAddressLastName, .AAddressCity, .contact__fields .name-input, #ContactForm .name-input"
      );
      alphaOnly.forEach(function (element) {
        element.addEventListener("beforeinput", function (event) {
          if (event.inputType === "deleteContentBackward") {
            return;
          }
          var value = this.value;
          if (
            !/^[a-zA-Z ]$/.test(event.data) ||
            (event.data === " " && value.length === 0)
          ) {
            event.preventDefault();
          }
        });
      });

      const numericOnly = document.querySelectorAll(".val-contact");
      numericOnly.forEach(function (element) {
        element.addEventListener("beforeinput", function (event) {
          const value = element.value;
          console.log("event", event, "value", value);

          // Allow backspace key
          if (event.inputType === "deleteContentBackward") {
            return;
          }

          // If input is not a number or current input is longer than 15, prevent input
          if (!/^\d$/.test(event.data) || value.length >= 15) {
            event.preventDefault();
            return;
          }

          // Ensure the first digit is greater than 5
          if (value.length === 0 && parseInt(event.data) <= 5) {
            event.preventDefault();
          }
        });
      });
    });

    // social icon csagre code

    $(".share-icon").on("click", function (e) {
      e.stopPropagation();

      var $dropdown = $(this).siblings(".share-dropdown-section");

      // Close any other open dropdowns
      $(".share-dropdown-section").not($dropdown).slideUp(150);

      // Toggle this one
      $dropdown.slideToggle(150);
    });

    // Close dropdown on share button click
    $(document).on("click", ".share-buttons--button", function () {
      $(".share-dropdown-section").slideUp(150);
    });

    // Close dropdown when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".share-wrapper").length) {
        $(".share-dropdown-section").slideUp(150);
      }
    });
    // pdp mobile filter
    const $pdpdropdown = $(".custom-dropdown");
    const $selected = $pdpdropdown.find(".dropdown-selected");
    const $options = $pdpdropdown.find(".dropdown-list li");

    // Toggle dropdown open/close
    $selected.on("click", function (e) {
      e.stopPropagation();
      $pdpdropdown.toggleClass("open");
    });

    // Handle option click
    $options.on("click", function () {
      const value = $(this).data("url");
      $selected.text($(this).text());
      $pdpdropdown.removeClass("open");
      if (value) window.location.href = value;
    });

    // Close dropdown when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".custom-dropdown").length) {
        $pdpdropdown.removeClass("open");
      }
    });

    function isValidEmail(email) {
      // Regular expression for a simple email validation
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    var $form = $("#ContactForm");
    var $formClone = $form.clone(true);
    $form.replaceWith($formClone);

    $("form[action='/contact#ContactForm']").submit(function (e) {
      e.stopPropagation();
      e.preventDefault();
      $(".error-form").remove();
      var FirstName = $("#ContactForm-name").val();
      var Contact = $("#ContactForm-phone").val();
      var Email = $("#ContactForm-email").val();
      var Enquiry = $("#ContactForm-body").val();

      if (FirstName == "") {
        $("#ContactForm-name")
          .closest(".field")
          .append('<div class="error-form">Please enter name</div>');
      } else {
        if (!charLimit(FirstName)) {
          $("#ContactForm-name")
            .closest(".field")
            .append('<div class="error-form">Please enter valid name</div>');
        }
      }
      if (Contact == "") {
        $("#ContactForm-phone")
          .closest(".field")
          .append('<div class="error-form">Please enter contact no.</div>');
      }
      if (Email == "") {
        $("#ContactForm-email")
          .closest(".field")
          .append('<div class="error-form">Please enter email</div>');
      } else {
        if (!isValidEmail(Email)) {
          $("#ContactForm-email")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
        if (!charLimit(Email)) {
          $("#ContactForm-email")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (Enquiry == "") {
        $("#ContactForm-body")
          .closest(".field")
          .append('<div class="error-form">Please enter enquiry</div>');
      }

      if (
        FirstName != "" &&
        Contact != "" &&
        Email != "" &&
        Enquiry != "" &&
        isValidEmail(Email) &&
        charLimit(FirstName) &&
        charLimit(Email)
      ) {
        console.log("in submit");
        //this.submit();

        var $form = $("#ContactForm");
        //console.log($form.serialize());
        jQuery.ajax({
          type: "POST",
          async: true,
          url: "/contact",
          data: $form.serialize(),
          beforeSend: function () {
            $form.addClass("sending");
          },
          error: function (responseerror) {
            if (responseerror.status == 429) {
              //console.log("inside the status");
              // var challengeUrl = window.location.origin + "/challenge#ContactForm";
              // window.location = challengeUrl;
              $(".form__too .many-request").show();
              e.preventDefault();
              return false;
            }
            $form.addClass("error");
          },
          success: function (response) {
            //your success message
            //window.location = window.location.origin+"/pages/contact?contact_posted=true#contact_form";
            $(".form__too .success-request").show();
            $("#ContactForm input,#ContactForm textarea").val("");
          },
        });
      } else {
        e.preventDefault();
        return false;
      }
    });

    // Login Page Css Start

    $(
      'input[type="password"],#CustomerEmail, #CustomerPassword, #RegisterForm-email,#RecoverEmail'
    ).on("cut copy paste", function (e) {
      e.preventDefault();
    });

    $("form[action='/account/login']").submit(function (e) {
      e.preventDefault();
      //$(".error-message").remove();
      $(".error-form").remove();
      var email = $("#CustomerEmail").val();
      var password = $("#CustomerPassword").val();
      if (email == "") {
        //$(".h_wizard").append('<div class="error-message">Please enter email</div>');
        $("#CustomerEmail")
          .closest(".field")
          .append('<div class="error-form">Please enter email</div>');
      } else {
        if (!isValidEmail(email)) {
          //$(".h_wizard").append('<div class="error-message">Please enter valid email</div>');
          $("#CustomerEmail")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (password == "") {
        //$(".h_wizard").append('<div class="error-message">Please enter password</div>');
        $("#CustomerPassword")
          .closest(".field")
          .append('<div class="error-form">Please enter password</div>');
      }
      if (email != "" && password != "" && isValidEmail(email)) {
        this.submit();
      }
    });

    $("form[action='/account']").submit(function (e) {
      e.preventDefault();
      $(".error-form").remove();
      var FirstName = $("#RegisterForm-FirstName").val();
      var LastName = $("#RegisterForm-LastName").val();
      var Accountemail = $("#RegisterForm-email").val();
      var AccountPassword = $("#RegisterForm-password").val();
      if (FirstName == "") {
        $("#RegisterForm-FirstName")
          .closest(".field")
          .append('<div class="error-form">Please enter first name</div>');
      }
      if (LastName == "") {
        $("#RegisterForm-LastName")
          .closest(".field")
          .append('<div class="error-form">Please enter last name</div>');
      }
      if (Accountemail == "") {
        $("#RegisterForm-email")
          .closest(".field")
          .append('<div class="error-form">Please enter valid email</div>');
      } else {
        if (!isValidEmail(Accountemail)) {
          $("#RegisterForm-email")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (AccountPassword == "") {
        $("#RegisterForm-password")
          .closest(".field")
          .append('<div class="error-form">Please enter password</div>');
      }

      if (
        FirstName != "" &&
        LastName != "" &&
        Accountemail != "" &&
        AccountPassword != "" &&
        isValidEmail(Accountemail)
      ) {
        this.submit();
      }
    });

    $("form[action='/account/recover']").submit(function (e) {
      e.preventDefault();
      $(".error-form").remove();
      var recoveremail = $("#RecoverEmail").val();
      if (recoveremail == "") {
        $("#RecoverEmail")
          .closest(".field")
          .append('<div class="error-form">Please enter valid email</div>');
      } else {
        if (!isValidEmail(recoveremail)) {
          $("#RecoverEmail")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (recoveremail != "" && isValidEmail(recoveremail)) {
        this.submit();
      }
    });

    $(document).on("submit", "form[action='/account/addresses']", function (e) {
      e.preventDefault();
      $(".error-form").remove();
      let FirstName = $("#AddressFirstNameNew").val();
      let Address = $("#AddressAddress1New").val();
      let City = $("#AddressCityNew").val();
      let Pincode = $("#AddressZipNew").val();
      let Phone = $("#AddressPhoneNew").val();
      if (FirstName == "") {
        $("#AddressFirstNameNew")
          .closest(".field")
          .append('<div class="error-form">Please enter first name</div>');
      } else {
        if (!charLimit(FirstName)) {
          $("#AddressFirstNameNew")
            .closest(".field")
            .append('<div class="error-form">Please enter valid name</div>');
          return false;
        }
      }
      if (Address == "") {
        $("#AddressAddress1New")
          .closest(".field")
          .append('<div class="error-form">Please enter address</div>');
      }
      if (City == "") {
        $("#AddressCityNew")
          .closest(".field")
          .append('<div class="error-form">Please enter city name</div>');
      } else {
        if (!charLimit(City)) {
          $("#AddressCityNew")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid city name</div>'
            );
          return false;
        }
      }
      if (Pincode == "") {
        $("#AddressZipNew")
          .closest(".field")
          .append('<div class="error-form">Please enter pincode</div>');
      } else {
        if (!pincodeLimit(Pincode)) {
          $("#AddressZipNew")
            .closest(".field")
            .append('<div class="error-form">Please enter valid pincode</div>');
          return false;
        }
      }
      if (Phone == "") {
        $("#AddressPhoneNew")
          .closest(".field")
          .append('<div class="error-form">Please enter contact no.</div>');
      } else {
        if (!numberLimit(Phone)) {
          $("#AddressPhoneNew")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid contact no.</div>'
            );
          return false;
        }
      }

      if (
        FirstName != "" &&
        Address != "" &&
        City != "" &&
        Pincode != "" &&
        Phone != ""
      ) {
        this.submit();
      }
    });

    $(document).on("submit", ".editadress form", function (e) {
      console.log("editform issue");
      e.preventDefault();
      $(".error-form").remove();
      let FirstName = $(this).find(".firstName").val();
      var Address = $(this).find(".address1").val();
      var City = $(this).find(".city").val();
      var Pincode = $(this).find(".pincode").val();
      var Phone = $(this).find(".contact").val();
      console.log(FirstName);
      if (FirstName == "") {
        $(this)
          .find(".firstName")
          .closest(".field")
          .append('<div class="error-form">Please enter first name</div>');
      } else {
        if (!charLimit(FirstName)) {
          $(this)
            .find(".firstName")
            .closest(".field")
            .append('<div class="error-form">Please enter valid name</div>');
          return false;
        }
      }

      if (Address == "") {
        $(this)
          .find(".address1")
          .closest(".field")
          .append('<div class="error-form">Please enter address</div>');
      }
      if (City == "") {
        $(this)
          .find(".city")
          .closest(".field")
          .append('<div class="error-form">Please enter city name</div>');
      } else {
        if (!charLimit(City)) {
          $(this)
            .find(".city")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid city name</div>'
            );
          return false;
        }
      }
      if (Pincode == "") {
        $(this)
          .find(".pincode")
          .closest(".field")
          .append('<div class="error-form">Please enter pincode</div>');
      } else {
        if (!pincodeLimit(Pincode)) {
          $(this)
            .find(".pincode")
            .closest(".field")
            .append('<div class="error-form">Please enter valid pincode</div>');
          return false;
        }
      }
      if (Phone == "") {
        $(this)
          .find(".contact")
          .closest(".field")
          .append('<div class="error-form">Please enter contact no.</div>');
      } else {
        if (!numberLimit(Phone)) {
          $(this)
            .find(".contact")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid contact no.</div>'
            );
          return false;
        }
      }

      if (
        FirstName != "" &&
        Address != "" &&
        City != "" &&
        Pincode != "" &&
        Phone != ""
      ) {
        this.submit();
      }
    });
  });

  // Email Subscription form
  function isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }
  const containers = document.querySelectorAll(".subscribe-form-container");
  console.log("ran");
  containers.forEach(function (formWrapper, index) {
    const form = formWrapper.querySelector(".subscribe-form");
    const emailInput = formWrapper.querySelector(".email-id");
    const thankYouMessage = formWrapper.querySelector(".thank-you-message");
    const errorBox = formWrapper.querySelector(".error-subscribe");

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const email = emailInput.value.trim();
      errorBox.style.display = "none";

      if (!isValidEmail(email)) {
        errorBox.textContent = "Please enter a valid email address.";
        errorBox.style.display = "block";
        return;
      }

      const formData = new FormData(form);

      fetch("/contact", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "text/html", // Shopify returns HTML, not JSON
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then(function (response) {
          if (response.status === 429) {
            errorBox.textContent = "Too many requests. Please try again later.";
            errorBox.style.display = "block";
            return;
          }

          if (!response.ok) {
            errorBox.textContent = "Something went wrong. Please try again.";
            errorBox.style.display = "block";
            return;
          }

          // Success (Shopify will send a 200 with HTML)
          form.style.display = "none";
          if (thankYouMessage) thankYouMessage.style.display = "block";
        })
        .catch(function (error) {
          console.error("Error submitting the form:", error);
          errorBox.textContent = "Network error. Please try again later.";
          errorBox.style.display = "block";
        });
    });

    // Input limit
    emailInput.addEventListener("beforeinput", function (event) {
      const text = event.target.value;
      const maxLength = 50;
      const selection = window.getSelection().toString();
      const inputType = event.inputType;

      if (
        text.length >= maxLength &&
        inputType !== "deleteContentBackward" &&
        selection === ""
      ) {
        event.preventDefault();
      }
    });
  });

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  // Function to get a cookie by name
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Store UTM parameters from URL in cookies
  const utmSource = getUrlParameter("utm_source");
  const utmCampaign = getUrlParameter("utm_campaign");
  const utmMedium = getUrlParameter("utm_medium");
  const utmTerm = getUrlParameter("utm_term");
  const utmContent = getUrlParameter("utm_content");

  if (utmSource) setCookie("utm_source", utmSource, 30);
  if (utmCampaign) setCookie("utm_campaign", utmCampaign, 30);
  if (utmMedium) setCookie("utm_medium", utmMedium, 30);
  if (utmTerm) setCookie("utm_term", utmTerm, 30);
  if (utmContent) setCookie("utm_content", utmContent, 30);

  const source = getCookie("utm_source");
  const campaign = getCookie("utm_campaign");
  const medium = getCookie("utm_medium");
  const term = getCookie("utm_term");
  const content = getCookie("utm_content");

  // if (source) $(".utm_source").val(source);
  // if (campaign) $(".utm_campaign").val(campaign);
  // if (medium) $(".utm_medium").val(medium);
  // if (term) $(".utm_term").val(term);
  // if (content) $(".utm_content").val(content);

  // Do not write your code below. ✋😠
}.call(window, window.jQuery);
